/**
 * @public
 * Default data structure V3.
 */
const defaultPhone = {
  product: null,
  src: null,
  publisher_click_id: null,
  session_id: null,
  user_id: null,
  sub_id: null,
  experiment_id: null,
  variation_id: null,
  device: null,
  placement: null,
  state: null,
  zip: null,
  request_url: null,
  site: null,
};

export default defaultPhone;
